import { Page } from '@/core/architecture'

import { ArtistThreadsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ArtistThreads Page
 * Implemented as a practical sample.
 */
export const ArtistThreads: Page = () => {
  const { state, actions } = useViewModel()

  return <ArtistThreadsTemplate state={state} {...actions} />
}
